export const DROPDOWN_LIST_ITEM_CATEGORY_KEY = 'base' as const;
export const DROPDOWN_LIST_ITEM_PARENT_COMPONENT_KEY = 'dropdown' as const;
export const DROPDOWN_LIST_ITEM_COMPONENT_KEY = 'listItem' as const;
